// extracted by mini-css-extract-plugin
export default {"content":"use-simple-dialog_content__Ic88P","actionButton":"use-simple-dialog_actionButton__8ceOl"};